import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment.development";
import {Injectable} from "@angular/core";
import {CalendarEvent} from "../../interfaces/shared-interface";
import {LoginServices} from "../../../auth/login/services/login.service";
import {
    EventoProyectoReq,
    EventoUsuarioReq
} from "../../../officials/inspecciones/components/interfaces/evento-asignacion-interface";
import {UsuarioAsignado} from "../../../officials/asignaciones/interfaces/asignacion-interface";
import {ProyectoItem} from "../../../users/interfaces/proyecto.interface";
import {
    ISolicitudEventoInterface
} from "../../../officials/inspecciones/components/interfaces/solicitud-evento-interface";

const apiVucUrl = environment.apiVucUrl
@Injectable({providedIn: 'root'})
export class CalendarEventService {
    private apiUrl = apiVucUrl + `api/v1.0/events`;
    constructor(private http: HttpClient, private loginServices: LoginServices) {
    }
    createEvent(event: CalendarEvent) {
        // event.creadoPor=this.loginServices.session()?.perfil.usuario
        event.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        console.log(`createEvent --> ${JSON.stringify(event)}`);
        return this.http.post(this.apiUrl, event);
    }
    getEvents(idStatus: number) {
        return this.http.get<CalendarEvent[]>(`${this.apiUrl}?idStatus=${idStatus}`, {observe: 'response'});
    }
    getEventsUser(idUsuario: string) {
        return this.http.get<CalendarEvent[]>(`${this.apiUrl}/asignacion-eventos?idUsuario=${idUsuario}`, {observe: 'response'});
    }
    getEventosByIdProyecto(idProyecto: string) {
        return this.http.get<CalendarEvent[]>(`${this.apiUrl}/proyecto/${idProyecto}`, {observe: 'response'});
    }
    getEventById(id: number) {
        return this.http.get<CalendarEvent>(`${this.apiUrl}/${id}`, {observe: 'response'});
    }
    getEventsCalendar() {
        return this.http.get<CalendarEvent[]>(`${this.apiUrl}/calendario`, {observe: 'response'});
    }
    updateEventStatus(id: number, event: any) {
        return this.http.put(`${this.apiUrl}/${id}`, event, {observe: 'response'});
    }
    updateEvent(event: CalendarEvent) {
        return this.http.put(`${this.apiUrl}`, event, {observe: 'response'});
    }
    deleteEvent(id: number) {
        return this.http.delete(`${this.apiUrl}/${id}`, {observe: 'response'});
    }
    getConsultarUsuariosPorIdEvento(id: number) {
        return this.http.get<UsuarioAsignado[]>(`${this.apiUrl}/${id}/usuarios`, {observe: 'response'});
    }
    getConsultarProyectosPorIdEvento(id: number) {
        return this.http.get<ProyectoItem[]>(`${this.apiUrl}/${id}/proyectos`, {observe: 'response'});
    }
    consultarAsignacion(idProyecto: string | undefined) {
        return this.http.get<UsuarioAsignado[]>(apiVucUrl + `api/v1.0/asignaciones?idProyecto=${idProyecto}`, {observe: 'response'})
    }
    aprobarEvent(event: CalendarEvent) {
        event.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        return this.http.put(`${this.apiUrl}/estado/aprobacion`, event, {observe: 'response'});
    }
    cancelarEvent(event:CalendarEvent) {
        event.session= {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        return this.http.put(`${this.apiUrl}/estado/cancelacion`, event, {observe: 'response'});
    }
    completarEvent(event:CalendarEvent) {
        event.session= {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        return this.http.put(`${this.apiUrl}/estado/completar`, event, {observe: 'response'});
    }
    agregarNuevasUsuariosAsignaciones(eventAsignacion: EventoUsuarioReq) {
        eventAsignacion.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        console.log(`agregarUsuarios --> ${JSON.stringify(eventAsignacion)}`);
        return this.http.post(`${this.apiUrl}/usuarios`, eventAsignacion);
    }
    agregarNuevosProyectosAsignaciones(eventAsignacion: EventoUsuarioReq) {
        eventAsignacion.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        console.log(`agregarProyectos --> ${JSON.stringify(eventAsignacion)}`);
        return this.http.post(`${this.apiUrl}/proyectos`, eventAsignacion);
    }
    removerUsuarios(eventAsignacion: EventoUsuarioReq) {
        eventAsignacion.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        console.log(`removerUsuarios --> ${JSON.stringify(eventAsignacion)}`);
        return this.http.put(`${this.apiUrl}/usuarios`, eventAsignacion);
    }
    removerProyectos(eventoProyectoAsignacion: EventoProyectoReq) {
        eventoProyectoAsignacion.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        }
        console.log(`removerUsuarios --> ${JSON.stringify(eventoProyectoAsignacion)}`);
        return this.http.put(`${this.apiUrl}/proyectos`, eventoProyectoAsignacion);
    }

    actualizarEstadoSolicitud(solicitudEvento :ISolicitudEventoInterface) {
        let url= apiVucUrl+`api/v1.0/`
        console.log("actulizarEstadoSolicitud")
        return this.http.post(`${url}/solicitud/estado`, solicitudEvento);
    }
}
